const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export function validBirthDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const [year, month, day] = value.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
}

export default function BirthDateFields({ value, onChange }) {
  const [year = "", month = "", day = ""] = value.split("-");
  const thisYear = new Date().getFullYear();
  const change = (index, next) => {
    const parts = [year, month, day];
    parts[index] = next;
    onChange(parts.every((part) => !part) ? "" : parts.join("-"));
  };
  const fields = [
    { label: "Month", index: 1, value: month, options: MONTHS.map((name, i) => [String(i + 1).padStart(2, "0"), name]) },
    { label: "Day", index: 2, value: day, options: Array.from({ length: 31 }, (_, i) => [String(i + 1).padStart(2, "0"), i + 1]) },
    { label: "Year", index: 0, value: year, options: Array.from({ length: 121 }, (_, i) => [String(thisYear - i), thisYear - i]) },
  ];
  return <div className="grid min-w-0 grid-cols-[1.4fr_1fr_1fr] gap-2">
    {fields.map((field) => <select key={field.label} aria-label={`Birth ${field.label.toLowerCase()}`}
      value={field.value} onChange={(e) => change(field.index, e.target.value)} required={Boolean(value)}
      className="min-w-0 w-full rounded-xl border border-white/10 bg-[#07110B] px-2 py-3 text-base text-white outline-none focus:border-[#D4AF37]">
      <option value="">{field.label}</option>
      {field.options.map(([key, label]) => <option key={key} value={key}>{label}</option>)}
    </select>)}
  </div>;
}
